import { DateTime } from 'luxon';

const convertIsoToLocaleString = (value: any) => {
    if (value == null) {
        return '';
    } else if (typeof value === 'string') {
        return DateTime.fromISO(value).toLocal().toFormat('MM/dd/yyyy');
    } else if (typeof value === 'object') {
        return DateTime.fromObject(value).toLocal().toFormat('MM/dd/yyyy');
    }
};

export { convertIsoToLocaleString };
